import React, { Suspense, lazy, useEffect } from "react";
import { Route, Switch } from "react-router";
import { connect } from "react-redux";
import lazyRetry from "./helpers/lazyRetry";
import withLayout from "./components/common/base";
import Auth from "./components/auth";
import CustomLoader from "./components/common/loader";
import idleTimeTracker from "./helpers/idleTimeTracker";
import { ROLE } from "./helpers/constants.js";

const Notifications = lazy(() =>
  lazyRetry(() => import("./components/common/notifications"), "notifications")
);
const GlobalSearch = lazy(() =>
  lazyRetry(() => import("./components/common/globalSearch"), "globalSearch")
);
const ContactUs = lazy(() =>
  lazyRetry(() => import("./components/contactUs/contactUs"), "contactUs")
);
const licenses = lazy(() =>
  lazyRetry(() => import("./components/licenses/index"), "licenses")
);
const cateWiseCourseList = lazy(() =>
  lazyRetry(
    () => import("./components/course/courseCategory/cateWiseCourseList"),
    "cateWiseCourseList"
  )
);
const DiscussionDetail = lazy(() =>
  lazyRetry(
    () => import("./components/discussions/discussionDetail"),
    "DiscussionDetail"
  )
);

const AssessmentName = lazy(() =>
  lazyRetry(
    () => import("./components/assessment/learner/Assessement/AssessmentName"),
    "AssessmentName"
  )
);

const SocialWallRoutes = lazy(() =>
  lazyRetry(
    () => import("./components/socialWall/socialWallRoutes"),
    "socialWallRoutes"
  )
);
const ReviewList = lazy(() =>
  lazyRetry(() => import("./components/dashboard/reviewList"), "reviewList")
);

const Dashboard = lazy(() =>
  lazyRetry(() => import("./components/dashboard/"), "dashboard")
);

const PlagiarismTool = lazy(() =>
  lazyRetry(() => import("./components/plagiarismTool"), "plagiarismTool")
);

const ApprovalWorkFlow = lazy(() =>
  lazyRetry(() => import("./components/approvalWorkFlows"), "approvalWorkFlows")
);

const Requests = lazy(() =>
  lazyRetry(() => import("./components/requests"), "requests")
);

const Certificate = lazy(() =>
  lazyRetry(() => import("./components/certificate"), "certificate")
);

const Feedback = lazy(() =>
  lazyRetry(() => import("./components/feedback"), "feedback")
);

// const ARVR = lazy(() => lazyRetry(() => import("./components/ARVR/"), "ARVR"));
// const ARVR2 = lazy(() =>
//   lazyRetry(() => import("./components/ARVR/arvr_2.js"), "ARVR2")
// );

const Course = lazy(() =>
  lazyRetry(() => import("./components/course/"), "course")
);
const AllCourse = lazy(() =>
  lazyRetry(
    () => import("./components/course/courseList/allCourses"),
    "allCourses"
  )
);

const CourseDetail = lazy(() =>
  lazyRetry(() => import("./components/course/courseDeatil/"), "CourseDetail")
);
// const CourseDetails = lazy(() =>
//   lazyRetry(
//     () => import("./components/course/courseDeatil/indexVideo"),
//     "indexVideo"
//   )
// );
const Events = lazy(() =>
  lazyRetry(() => import("./components/events/"), "events")
);

const CustomerListView = lazy(() =>
  lazyRetry(() => import("./components/adminDashboard/index"), "admiDashboard")
);
// const CustomerListViewTest = lazy(() =>
//   lazyRetry(
//     () => import("./components/aminDashboard/TrainerView/index"),
//     "CustomerList"
//   )
// );
const Profile = lazy(() =>
  lazyRetry(() => import("./components/profile/index"), "profile-index")
);
const MyProfile = lazy(() =>
  lazyRetry(() => import("./components/profile/myprofile"), "profile-myprofile")
);
const Support = lazy(() =>
  lazyRetry(() => import("./components/contactUs/contactUs"), "contactUs")
);

const AdminLearning = lazy(() =>
  lazyRetry(
    () => import("./components/learningPathDemo/index"),
    "admiDashboard"
  )
);
const LearningPath = lazy(() =>
  lazyRetry(
    () => import("./components/learningPath/index"),
    "learningPath-index"
  )
);

const Signin = lazy(() =>
  lazyRetry(() => import("./components/signin/"), "signin")
);
const SuperAdminSignIn = lazy(() =>
  lazyRetry(
    () => import("./components/signin/superAdmin/"),
    "signin-superAdmin"
  )
);
// const UnAssignedCourses = lazy(() =>
//   import("./components/course/courseCategory/unAssigned")
// );
const NotFound = lazy(() =>
  lazyRetry(() => import("./components/common/notFound"), "notFound")
);
const Signup = lazy(() =>
  lazyRetry(() => import("./components/signup/"), "signup")
);
const VerifyEmail = lazy(() =>
  lazyRetry(() => import("./components/signup/verifyEmail"), "verifyEmail")
);
const RecoverAccount = lazy(() =>
  lazyRetry(
    () => import("./components/signin/recoverAccount"),
    "recoverAccount"
  )
);
const PasswordForgotten = lazy(() =>
  lazyRetry(
    () => import("./components/signin/passwordForgotten"),
    "passwordForgotten"
  )
);
const PasswordForgottenOtp = lazy(() =>
  lazyRetry(
    () => import("./components/signin/passowrdResetmobile"),
    "passowrdResetmobile"
  )
);
const PasswordReset = lazy(() =>
  lazyRetry(() => import("./components/signin/passwordReset"), "passwordReset")
);
const UserImport = lazy(() =>
  lazyRetry(() => import("./components/userImport/index"), "userImport-index")
);
const AddCourse = lazy(() =>
  lazyRetry(() => import("./components/course/admin/addCourse.js"), "addCourse")
);
const editCourseAdmin = lazy(() =>
  lazyRetry(
    () => import("./components/course/admin/editCourseAdmin.js"),
    "editCourseAdmin"
  )
);
const CategoryDetail = lazy(() =>
  lazyRetry(
    () => import("./components/course/courseCategory/categoryDetail"),
    "categoryDetail"
  )
);
// const Certificate = lazy(() =>
//   import("./components/customCertificate/customCertificate")
// );
//const VideoContent = lazy(()=>import('./components/course/courseCategory/videoContent'));
const MediaDetail = lazy(() =>
  lazyRetry(
    () => import("./components/course/courseCategory/mediaDetail"),
    "mediaDetail"
  )
);
const AddCourseModule = lazy(() =>
  lazyRetry(
    () => import("./components/course/admin/courseModule"),
    "courseModule"
  )
);
const CourseFaq = lazy(() =>
  lazyRetry(() => import("./components/course/admin/courseFaq"), "courseFaq")
);
const CourseReview = lazy(() =>
  lazyRetry(
    () => import("./components/course/admin/courseReview"),
    "courseReview"
  )
);

const Assessment = lazy(() =>
  lazyRetry(() => import("./components/assessment"), "assessment")
);
const AttemptedSubjects = lazy(() =>
  lazyRetry(
    () => import("./components/assessment/admin/attemptedSubjects"),
    "attemptedSubjects"
  )
);
const AttemptedUserDetails = lazy(() =>
  lazyRetry(
    () => import("./components/assessment/admin/attemptedUserDetails"),
    "attemptedUserDetails"
  )
);
const AsssesmentResults = lazy(() =>
  lazyRetry(
    () => import("./components/assessment/admin/asssesmentResults"),
    "asssesmentResults"
  )
);
const EditAssessment = lazy(() =>
  lazyRetry(
    () => import("./components/assessment/editAssessment"),
    "editAssessment"
  )
);
const AttendeesList = lazy(() =>
  lazyRetry(
    () => import("./components/assessment/attendeesList"),
    "attendeesList"
  )
);
const QuestionBank = lazy(() =>
  lazyRetry(
    () => import("./components/assessment/questionBank"),
    "questionBank"
  )
);
// const AssessmentDetail = lazy(() =>
//   lazyRetry(
//     () => import("./components/course/courseCategory/assessmentList"),
//     "assessmentList"
//   )
// );
const Themes = lazy(() =>
  lazyRetry(() => import("./components/themes"), "themes")
);
const Leaderboard = lazy(() =>
  lazyRetry(() => import("./components/leaderboard"), "leaderboard")
);
// const UserDetails = lazy(() =>
//   import("./components/leaderboard/admin/badgeUserDetails")
// );
const ProfileDetails = lazy(() =>
  lazyRetry(
    () => import("./components/leaderboard/admin/profileDetails"),
    "profileDetails"
  )
);
const Announcements = lazy(() =>
  lazyRetry(() => import("./components/announcements"), "announcements")
);

const Discussions = lazy(() =>
  lazyRetry(() => import("./components/discussions"), "discussions")
);
const Blogs = lazy(() =>
  lazyRetry(() => import("./components/discussions/blog"), "blog")
);
// const Organization = lazy(() => import("./components/organization"));
const ClassRoom = lazy(() =>
  lazyRetry(() => import("./components/addClassrooms"), "addClassrooms")
);
const AddClassRoom = lazy(() =>
  lazyRetry(
    () => import("./components/addClassrooms/AddClassRoom"),
    "AddClassRoom"
  )
);
const ClassRoomAddSession = lazy(() =>
  lazyRetry(
    () => import("./components/classroom/classroomTrainer/session"),
    "session"
  )
);
const ClassRoomAttendees = lazy(() =>
  lazyRetry(
    () => import("./components/classroom/detailedAttendees"),
    "detailedAttendees"
  )
);
const Reports = lazy(() =>
  lazyRetry(() => import("./components/reports"), "reports")
);
const DownloadReport = lazy(() =>
  lazyRetry(
    () => import("./components/downloadReport/DownloadReport"),
    "downloadReport"
  )
);
const CPD = lazy(() => lazyRetry(() => import("./components/cpd/cpd"), "cpd"));

const CPDView = lazy(() =>
  lazyRetry(() => import("./components/cpd/CPDView"), "cpdView")
);

const Competency = lazy(() =>
  lazyRetry(() => import("./components/competency"), "competency")
);
// const CustomReport = lazy(() =>
//   lazyRetry(
//     () => import("./components/reports/CustomReport/customReport"),
//     "customReport"
//   )
// );
const ToolsPlugins = lazy(() =>
  lazyRetry(() => import("./components/toolsPlugins"), "toolsPlugins")
);
const Messsage = lazy(() =>
  lazyRetry(() => import("./components/messages"), "messages")
);
const ARVRStudio = lazy(() =>
  lazyRetry(import("./components/arvr-studio"), "arvr-studio")
);
const AddProfile = lazy(() =>
  lazyRetry(() => import("./components/profile/addProfile"), "addProfile")
);
const AllCoursesList = lazy(() =>
  lazyRetry(
    () => import("./components/course/courseCategory/allCoursesList"),
    "allCoursesList"
  )
);
const CourseList = lazy(() =>
  lazyRetry(
    () => import("./components/course/courseList/courseList"),
    "courseList"
  )
);
const Assigned = lazy(() =>
  lazyRetry(
    () => import("./components/course/courseCategory/assigned"),
    "assigned"
  )
);
const unAssigned = lazy(() =>
  lazyRetry(
    () => import("./components/course/courseCategory/unAssigned"),
    "unAssigned"
  )
);
const AllAssignList = lazy(() =>
  lazyRetry(
    () => import("./components/course/courseCategory/allAssignList"),
    "allAssignList"
  )
);
const AddDialog = lazy(() =>
  lazyRetry(
    () => import("./components/course/admin/courseModule/addModule"),
    "addModule"
  )
);
const profileByID = lazy(() =>
  lazyRetry(() => import("./components/profile/profileById"), "profileById")
);
const LearningCourse = lazy(() =>
  lazyRetry(
    () => import("./components/learningPath/learningCourse"),
    "learningCourse"
  )
);
const AnnouncementsDetail = lazy(() =>
  lazyRetry(
    () => import("./components/announcements/announcementsDetail"),
    "announcementsDetail"
  )
);
// const HomePage = lazy(() => import("./components/brihhaConnect/App"));
// const VCHomePage = lazy(() => lazyRetry(() => import("./components/VC"), "VC"));
const StaticRoute = lazy(() =>
  lazyRetry(() => import("./components/staticRoute"), "staticRoute")
);
const ProctorOld = lazy(() =>
  lazyRetry(() => import("./components/proctor"), "proctor")
);
const Proctor = lazy(() =>
  lazyRetry(
    () => import("./components/assessment/proctor"),
    "assessment-proctor"
  )
);

const UserManualPage = lazy(() =>
  lazyRetry(() => import("./components/usermanual/index"), "user_manual")
);

const EndMeet = lazy(() =>
  lazyRetry(() => import("./components/endMeet/index"), "end_meet")
);
// const Evidance = lazy(() =>
//   lazyRetry(
//     () =>
//       import("./components/assessment/proctor/proctorBottom/listView/edivance"),
//     "edivance"
//   )
// );
// const ProctorViewCard = lazy(() =>
//   lazyRetry(
//     () =>
//       import("./components/assessment/proctor/proctorTypes/proctorMainCard"),
//     "proctorMainCard"
//   )
// );

function withLoader(Component) {
  return (props) => (
    <Suspense fallback={<CustomLoader />}>
      <Component {...props} />
    </Suspense>
  );
}
const { token } = window.localStorage;
const Routes = ({ session }) => {
  const callBackIdleTimer = () => {
    const token = localStorage.getItem("token");
    if (typeof token === "undefined" || token === "") {
      return;
    }
    localStorage.setItem("token", "");
    localStorage.setItem(
      "lastActiveModule",
      window.location.pathname.split("/")[1]
    );
    window.location.href = "/";
  };
  useEffect(() => {
    const idleTimer = idleTimeTracker({
      callBack: callBackIdleTimer,
      IdleTimeOut: 30,
      message: "",
      showAlert: false,
    });
    return () => {
      idleTimer.removeIdleTimer();
    };
  }, []);

  function withPermissions(Component, allowedUserRoles = []) {
    const isAllowed = allowedUserRoles.includes(session?.membership?.role?.id);
    return isAllowed ? withLoader(Component) : withLoader(NotFound);
  }

  const managerRole = [
    parseInt(ROLE.superadmin),
    parseInt(ROLE.admin),
    parseInt(ROLE.trainer),
  ];
  const modulePermissions = session?.profile?.permissions;

  const permissionsData = [];

  if (typeof modulePermissions !== "undefined" && modulePermissions !== "") {
    const parsedData = JSON.parse(modulePermissions);
    for (var i in parsedData) {
      if (parsedData[i].permission) {
        permissionsData.push(parsedData[i].href);
      }
    }
  }

  return (
    <Switch>
      <Route exact path="/" component={withLayout(withLoader(Signin))} />
      <Route exact path="/login" component={withLayout(withLoader(Signin))} />
      <Route
        exact
        path="/sa"
        component={withLayout(withLoader(SuperAdminSignIn))}
      />
      {/* <Route exact path="/404" component={withLayout(withLoader(NotFound))} /> */}
      {/* <Route exact path="/arvr" component={withLayout(withLoader(ARVR))} />
      <Route exact path="/arvr_2" component={withLayout(withLoader(ARVR2))} /> */}
      <Route exact path="/signup" component={withLayout(withLoader(Signup))} />
      <Route
        exact
        path="/verify-email/:uid/:token"
        component={withLayout(withLoader(VerifyEmail))}
      />
      <Route
        exact
        path="/password/reset/confirm/:uid/:token"
        component={withLayout(withLoader(PasswordReset))}
      />
      <Route
        exact
        path="/password/reset/"
        component={withLayout(withLoader(PasswordForgotten))}
      />
      <Route
        exact
        path="/password/reset/Otp/"
        component={withLayout(withLoader(PasswordForgottenOtp))}
      />
      <Route
        exact
        path="/password/recover"
        component={withLayout(withLoader(RecoverAccount))}
      />
      {/* <Auth> */}
      <Auth path="/certificate" component={withLoader(Certificate)} />
      <Auth path="/feedback" component={withLoader(Feedback)} />

      <Auth
        path="/socialwall"
        component={withLoader(SocialWallRoutes)}
        isPermitted={modulePermissions?.includes("/socialwall")}
      />
      <Auth
        path="/settings"
        component={withLoader(ApprovalWorkFlow)}
        isPermitted={modulePermissions?.includes("/settings")}
      />
      <Auth path="/requests" component={withLoader(Requests)} />
      <Auth path="/dashboard" component={withLoader(Dashboard)} />
      <Auth
        path="/plagiarism"
        component={withLoader(PlagiarismTool)}
        isPermitted={modulePermissions?.includes("/plagiarism")}
      />
      <Auth path="/reviewlist" component={withLoader(ReviewList)} />
      <Auth path="/notifications" component={withLoader(Notifications)} />
      <Auth path="/search" component={withLoader(GlobalSearch)} />
      <Auth path="/contactUs" component={withLoader(ContactUs)} />
      <Auth path="/myprofile" component={withLoader(MyProfile)} />
      <Auth path="/support" component={withLoader(Support)} />
      <Auth path="/licenses" component={withLoader(licenses)} />
      <Auth
        exact
        path="/organization"
        component={withLoader(CustomerListView)}
        isPermitted={modulePermissions?.includes("/organization")}
      />
      {/* <Auth
        exact
        path="/organizationold"
        component={withLoader(CustomerListViewTest)}
      /> */}
      <Auth
        path="/organization/profile/:id"
        component={withLoader(Profile)}
        isPermitted={modulePermissions?.includes("/organization")}
      />
      <Auth path="/profile_by_id/:id" component={withLoader(profileByID)} />
      <Auth
        exact
        path="/learning-path"
        component={withLoader(AdminLearning)}
        isPermitted={modulePermissions?.includes("/learning-path")}
      />
      <Auth
        path="/calendar"
        component={withLoader(Events)}
        isPermitted={modulePermissions?.includes("/calendar")}
      />
      <Auth path="/user-import" component={withLoader(UserImport)} />
      <Auth
        path="/courses/all-courses"
        component={withLoader(AllCourse)}
        isPermitted={modulePermissions?.includes("/courses")}
      />
      <Auth
        exact
        path="/courses"
        component={withLoader(Course)}
        isPermitted={modulePermissions?.includes("/courses")}
      />
      <Auth path="/course-module/:id" component={withLoader(AddCourseModule)} />
      <Auth
        path="/courses/course-detail/:id"
        component={withLoader(CourseDetail)}
        isPermitted={modulePermissions?.includes("/courses")}
      />
      {/* <Auth
        path="/course-details/:id"
        component={withLoader(CourseDetails)}
        isPermitted={modulePermissions?.includes("/courses")}
      /> */}
      {/* <Auth path='/course-details/:id' component={withLoader(CourseDetails)} /> */}
      <Auth path="/courses/add-course" component={withLoader(AddCourse)} />
      {/* <Auth
          path="/assessment/results"
          component={withLoader(AsssesmentResults)}
        /> */}
      <Auth
        path="/assessment/results/:id"
        component={withLoader(AsssesmentResults)}
        isPermitted={modulePermissions?.includes("/assessment")}
      />
      <Auth
        path="/courses/edit-course/:id"
        component={withLoader(editCourseAdmin)}
        isPermitted={modulePermissions?.includes("/courses")}
      />
      <Auth
        path="/courses/edit-course-cate/:id"
        component={withLoader(editCourseAdmin)}
        isPermitted={modulePermissions?.includes("/courses")}
      />
      <Auth
        path="/courses/course-category-detail"
        component={withLoader(CategoryDetail)}
        isPermitted={modulePermissions?.includes("/courses")}
      />
      <Auth
        path="/courses/course-media-detail/:type"
        component={withLoader(MediaDetail)}
        isPermitted={modulePermissions?.includes("/courses")}
      />
      <Auth
        path="/courses/course-faq/:id"
        component={withLoader(CourseFaq)}
        isPermitted={modulePermissions?.includes("/courses")}
      />
      <Auth
        path="/courses/course-review/:id"
        component={withLoader(CourseReview)}
        isPermitted={modulePermissions?.includes("/courses")}
      />
      <Auth
        exact
        path="/assessment"
        component={withLoader(Assessment)}
        isPermitted={modulePermissions?.includes("/assessment")}
      />

      <Auth
        path="/assessment/result/:id"
        component={withLoader(AttemptedUserDetails)}
        isPermitted={modulePermissions?.includes("/assessment")}
      />
      <Auth
        path="/assessment/review"
        component={withLoader(AttemptedSubjects)}
        isPermitted={modulePermissions?.includes("/assessment")}
      />
      <Auth
        path="/assessment/edit-assessment/:id"
        component={withLoader(EditAssessment)}
        isPermitted={modulePermissions?.includes("/assessment")}
      />
      <Auth
        path="/assessment/attendees-list/:id"
        component={withLoader(AttendeesList)}
      />
      <Auth
        path="/assessment/question-bank"
        component={withLoader(QuestionBank)}
        isPermitted={modulePermissions?.includes("/assessment")}
      />
      {/* <Auth exact path="/brihhaconnect" component={withLoader(HomePage)} /> */}
      {/* <Auth
          path="/brihhaconnect/:meetingId"
          component={withLoader(HomePage)}
        /> */}
      {/* <Auth
          path="/video-conferencing/:meetingId"
          component={withLoader(HomePage)}
        /> */}
      <Auth path="/themes" component={withLoader(Themes)} />
      <Auth path="/leaderboard" exact component={withLoader(Leaderboard)} />
      <Auth path="/leaderboard/:id" component={withLoader(ProfileDetails)} />
      <Auth path="/messages" component={withLoader(Messsage)} />
      <Auth
        exact
        path="/announcements"
        component={withLoader(Announcements)}
        isPermitted={modulePermissions?.includes("/announcements")}
      />
      <Auth
        exact
        path="/discussions"
        component={withLoader(Discussions)}
        isPermitted={modulePermissions?.includes("/discussions")}
      />
      {/* <Auth path="/organization
        " component={withLoader(Organization)} /> */}
      <Auth
        path="/reports"
        component={withLoader(Reports)}
        isPermitted={modulePermissions?.includes("/reports")}
      />
      <Auth
        path="/download-report/:id"
        component={withLoader(DownloadReport)}
        isPermitted={modulePermissions?.includes("/reports")}
      />
      <Auth
        path="/cpd"
        component={withLoader(CPD)}
        isPermitted={modulePermissions?.includes("/cpd")}
      />
      <Auth
        path="/cpd-view/:uid"
        component={withLoader(CPDView)}
        isPermitted={modulePermissions?.includes("/cpd")}
      />
      <Auth
        path="/competency"
        component={withLoader(Competency)}
        isPermitted={modulePermissions?.includes("/competency")}
      />
      <Auth path="/tools-plugins" component={withLoader(ToolsPlugins)} />
      <Auth path="/admin" component={withLoader(CustomerListView)} />
      <Auth path="/ar-vr-studio" component={withLoader(ARVRStudio)} />
      <Auth path="/newProfile" component={withLoader(AddProfile)} />
      <Auth
        path="/classroom"
        exact
        component={withLoader(ClassRoom)}
        isPermitted={modulePermissions?.includes("/classroom")}
      />
      {/* <Auth path="/classrooms" exact component={withLoader(ClassRooms)} /> */}
      <Auth
        path="/classroom/classes"
        exact
        component={withLoader(AddClassRoom)}
        isPermitted={modulePermissions?.includes("/classroom")}
      />
      <Auth
        path="/classroom/classes/edit"
        exact
        component={withLoader(AddClassRoom)}
        isPermitted={modulePermissions?.includes("/classroom")}
      />
      <Auth
        path="/classroom/add-session"
        component={withLoader(ClassRoomAddSession)}
        isPermitted={modulePermissions?.includes("/classroom")}
      />
      {/* <Auth
        path="/courses/course-detail-assessment"
        component={withLoader(AssessmentDetail)}
        isPermitted={modulePermissions?.includes("/courses")}
      /> */}
      <Auth
        path="/classroom/attendees/:id"
        component={withLoader(ClassRoomAttendees)}
        isPermitted={modulePermissions?.includes("/classroom")}
      />
      <Auth
        path="/courses/admin-all-course-detail"
        component={withLoader(AllCoursesList)}
        isPermitted={modulePermissions?.includes("/courses")}
      />
      {/* <Auth path="/course-cate-learner" component={withLoader(courseCategoriesLearner)} /> */}
      {/* <Auth path="/detail" component={withLoader(AnnouncementDetail)} /> */}
      <Auth
        path="/course/:id"
        component={withLoader(CourseList)}
        isPermitted={modulePermissions?.includes("/courses")}
      />
      <Auth
        path="/asssigned_course"
        component={withLoader(Assigned)}
        isPermitted={modulePermissions?.includes("/courses")}
      />
      <Auth
        path="/unasssigned_course"
        component={withLoader(unAssigned)}
        isPermitted={modulePermissions?.includes("/courses")}
      />
      <Auth
        exact
        path="/courses/category_course_list/:id"
        component={withLoader(cateWiseCourseList)}
        isPermitted={modulePermissions?.includes("/courses")}
      />
      <Auth
        path="/all_assigned_courses_list/:id"
        component={withLoader(AllAssignList)}
        isPermitted={modulePermissions?.includes("/courses")}
      />
      <Auth
        path="/courses/module/:id"
        component={withLoader(AddDialog)}
        isPermitted={modulePermissions?.includes("/courses")}
      />
      <Auth
        exact
        path="/learning-path/:id"
        component={withLoader(LearningPath)}
        isPermitted={modulePermissions?.includes("/learning-path")}
      />
      <Auth
        exact
        path="/discussions/:id"
        component={withLoader(DiscussionDetail)}
        isPermitted={modulePermissions?.includes("/discussions")}
      />
      <Auth
        exact
        path="/learning-path/learner/learning-path/:id"
        component={withLoader(LearningCourse)}
        isPermitted={modulePermissions?.includes("/learning-path")}
      />
      <Auth path="/blogs" component={withLoader(Blogs)} />
      <Auth
        exact
        path="/assessment/start"
        component={withLoader(AssessmentName)}
        isPermitted={modulePermissions?.includes("/assessment")}
      />

      <Auth
        path="/announcements/:id/"
        component={withLoader(AnnouncementsDetail)}
        isPermitted={modulePermissions?.includes("/announcements")}
      />
      <Auth
        path="/assessment/:id/proctor/"
        exact
        component={withLoader(Proctor)}
        isPermitted={modulePermissions?.includes("/assessment")}
      />
      <Auth
        path="/assessment/:id/proctor-view-card/:groupId"
        exact
        component={withLoader(Proctor)}
        isPermitted={modulePermissions?.includes("/assessment")}
      />
      <Auth
        path="/assessment/:id/proctor-view-card/:groupId/:evidence"
        exact
        component={withLoader(Proctor)}
        isPermitted={modulePermissions?.includes("/assessment")}
      />
      <Auth
        exact
        path="/assessment/:uuid"
        // component={withLoader(RedirectAssessment)}
        component={withLoader(AssessmentName)}
        isPermitted={modulePermissions?.includes("/assessment")}
      />
      <Auth
        path="/assessment/proctor-view-old"
        exact
        component={withLoader(ProctorOld)}
        isPermitted={modulePermissions?.includes("/assessment")}
      />

      <Auth path="/user-manual" exact component={withLoader(UserManualPage)} />
      <Auth path="/end-meet/:uuid" exact component={withLoader(EndMeet)} />

      <Route path="/hls" component={withLoader(StaticRoute)} />
      {/* </Auth> */}
      <Route path="*" component={withLoader(NotFound)} />
    </Switch>
  );
};

const mapStateToProps = (state) => ({
  session: state.session,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Routes);
